import { useDispatch, useSelector } from "react-redux";

import { onShow, onDismiss } from "../features/alert/slice";
import { capitalFirstLetter } from "../config/functions";

export default () => {
  const dispatch = useDispatch();
  const { show, type, body } = useSelector(state => state.alert)

  const showAlert = (body, type) => {
    body = capitalFirstLetter(body)
    dispatch(onShow({ body, type }))
    if (!show)
      setTimeout(dismissAlert, 3000)
  }
  const dismissAlert = () => dispatch(onDismiss())

  return {
    body,
    type,
    show,
    showAlert,
    dismissAlert
  }
}